<div class="desktop-view">
  <div class="tab-parent">
    <!-- sequenceVersionDate: {{entryData().sequenceVersionDate.split('T')[0]}}<br />
    uniprot sequence.modified : {{uniprotData().sequence.modified}}  -->

    @if (isOldUniprotEntry) {
      <section>
        <notification-msg
          [type]="'warning'"
          [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
        </notification-msg>
      </section>
    }
    @if (summaryTexts.length > 0 && entryData().isComplex  !== true) {
      <section class="domain-info">
        @for (group of summaryTexts; track group; let isLast = $last) {
          <div class="domain-info-grouped">
            @for (item of group; track item) {
              @if (item.label === 'Experimental structures' && alsoFoundInCount() !== null) {
                <div class="info-row">
                  <span>Found in</span>
                  <article>
                    @if (isAlsoFoundInLoading()) {
                      <span>Loading...</span>
                    }
                    @if (!isAlsoFoundInLoading() && alsoFoundInCount() !== null) {
                      <span>
                        {{ alsoFoundInCount() }} entries in AFDB
                        @if (entryData().uniprotAccession) {
                          <a
                            [href]="'/search/text/' + (entryData().uniprotAccession)"
                            class="vf-link ext"
                            style="margin-left: 4px;"
                            target="_blank"
                            (click)="onRelatedEntryClick('found_in')"
                          >go to search</a>
                        }
                      </span>
                    }
                  </article>
                </div>
              }
              <div class="info-row">
                @if (item.label !== 'Average pLDDT') {
                  <span>
                    {{ item.label }}
                  </span>
                }
                @if (item.source && item.source === 'tooltip' && item.label === 'Average pLDDT') {
                  <span >
                    {{ item.label }}<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Mean pLDDT score for residues across the full-length protein. Indicates AlphaFold confidence.'" [isOnlytext]="false" />
                  </span>
                }
                <ng-container>
                  <article>
                    @if (item.label != 'Status') {
                      <span>
                        @if (item.label === 'Biological function' && isBiologicalFunctionLoading()) {
                          <span>Loading...</span>
                        }
                        @if (item.show_long) {
                          <span>
                            @if (item.label !== 'Biological function' || !isBiologicalFunctionLoading()) {
                              <span [innerHTML]="item.text" [ngClass]="{'italic-text': item.italic}"></span>
                            }
                            @if (getShortenedText(item.text) != item.text) {
                              <a
                                class="vf-link"
                                (click)="switchText(item)"
                                >
                                <i class="icon icon-functional"></i> Show less
                              </a>
                            }
                          </span>
                        }
                        @if (!item.show_long) {
                          <span>
                            @if (item.label !== 'Biological function' || !isBiologicalFunctionLoading()) {
                              <span [innerHTML]="getShortenedText(item.text)" [ngClass]="{'italic-text': item.italic}"></span>
                            }
                            @if (checkIfHasToShowMore(item)) {
                              <a
                                class="vf-link"
                                (click)="switchText(item)"
                                >
                                <i class="icon icon-functional"></i> Show more
                              </a>
                            }
                          </span>
                        }
                      </span>
                    }
                    @if (item.source && item.source !== 'tooltip') {
                      <a
                        target="_blank"
                        href="{{ item.source_url }}"
                        class="vf-link ext"
                        >
                        go to {{ item.source }}</a
                        >
                      }
                      @if (item.italic) {
                        <span
                          ><a
                          class="vf-link ext"
                  href="./search/organismScientificName/{{
                    commonService.escapeValue(item.searchText)
                  }}"
                          target="_blank"
                          > go to search </a
                          ></span
                          >
                        }
                      </article>
                    </ng-container>
                  </div>
                }
                @if (isLast && plddtData) {
                  <div class="info-row plddt-summary">
                    <span>pLDDT distribution</span>
                    <article style="display:flex; flex-direction: row;">
                      <div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #0053d6;">&nbsp;</span>
                          {{ (plddtData?.fractionPlddtVeryHigh * 100) | number : '1.0-1' }}% Very high
                        </div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #65cbf3;">&nbsp;</span>
                          {{ (plddtData?.fractionPlddtConfident * 100) | number : '1.0-1' }}% High
                        </div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #ffdb13;">&nbsp;</span>
                          {{ (plddtData?.fractionPlddtLow * 100) | number : '1.0-1' }}% Low
                        </div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #ff7d45;">&nbsp;</span>
                          {{ (plddtData?.fractionPlddtVeryLow * 100) | number : '1.0-1' }}% Very low
                        </div>
                      </div>
                    </article>
                  </div>
                }
              </div>
            }
          </section>
        }

        @if (entryData().isComplex) {
          <section class="domain-info">
            <div class="domain-info-grouped">
              <div class="info-row">
                <span>
                  Components
                </span>
                <article>
                  @for (comp of summaryComponents(); track comp) {
                    <span class="comp-article">
                      <span>{{ comp.stoichiometry }} {{ comp.stoichiometry > 1 ? 'copies' : 'copy' }} of {{ comp.identifier }}
                        @if (comp.range) {
                          [residues: {{ comp.range.start }} – {{ comp.range.end }}]
                        }
                        ({{ comp.uniprotDescription }}) <br />
                        @if (comp.uniprotAccession) {
                          <a href="{{uniprotBaseUrl}}{{comp.uniprotAccession}}" class="vf-link ext" style="margin-left: 0px;" target="_blank"> go to UniProt </a>
                        }
                      </span>
                    </span>
                  }
                </article>
              </div>
              <div class="info-row">
                <span>
                  Source organism{{ complexData().organismScientificName?.length > 1 ? 's' : '' }}
                </span>
                <article>
                  @for (organism of complexData().organismScientificName; track organism; let i = $index) {
                    <span class="comp-article">
                      <span><i>{{ organism }}</i>
                      <a href="./search/organismScientificName/{{commonService.escapeValue(organism)}}" class="vf-link ext" style="margin-left: 0px;" target="_blank"> go to search </a>
                    </span>
                  </span>
                }
              </article>
            </div>
            <!-- <div class="info-row">
            <span>
              Experimental complex
            </span>
            <article>
              <span>
                <span *ngIf="complexKBCount > 0">{{complexKBCount}} structure in PDB for {{complexData().uniprotAccession[0]}}  <a href="https://www.ebi.ac.uk/pdbe/pdbe-kb/proteins/{{complexData().uniprotAccession[0]}}" target="_blank" style="margin-left: 0px;" class="vf-link ext">go to PDBe-KB</a> </span>
                <span *ngIf="complexKBCount === 0">None available in the PDB </span>
              </span>
            </article>
          </div> -->
          @if (curatedComplexId) {
            <div class="info-row">
              <span>
                Curated complex
              </span>
              <article>
                <span>
                  This complex is curated
                  <a [href]="getCuratedComplexPortalUrl()" target="_blank" style="margin-left: 0px;" class="vf-link ext">go to Complex portal</a>
                </span>
              </article>
            </div>
          }
        </div>
        <div class="domain-info-grouped">
          <div class="info-row">
            <span>Global quality </span>
            <article style="display:flex; flex-direction: row;">
              <div>
                <div class="plddtlegends">
                  <span class="plddt-label">average pLDDT<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Mean pLDDT score for residues across the full-length protein. Indicates AlphaFold confidence.'" [isOnlytext]="false" /></span>
                  <span>{{complexData().globalMetricValue}} ({{getPlddtLevel(complexData().globalMetricValue)}})</span>
                </div>
              </div>
            </article>
          </div>
          <div class="info-row">
            <span>Interface quality </span>
            <article style="display:flex; flex-direction: row;">
              <div>
                <div class="plddtlegends">
                  <span class="plddt-label">ipSAE<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Interaction prediction score from aligned errors (ipSAE) focuses on inter-chain residue pairs with more reliable predicted positioning, making it less sensitive to disordered or non-interacting regions.'" [isOnlytext]="false" /></span>
                  <span>{{complexData().complexPredictionAccuracy_ipSAE}} ({{ getipSAELevel(complexData().complexPredictionAccuracy_ipSAE) }})
                    <a href="/faq/#faq-34" target="_blank" style="margin-left: 0px;" class="vf-link ext">read about scores</a>
                  </span>
                </div>
                <div class="plddtlegends">
                  <span class="plddt-label">ipTM<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Interface predicted TM-score (ipTM) measures confidence in the predicted relative positions of the protein chains in a complex.'" [isOnlytext]="false" /></span>
                  <span>{{complexData().complexPredictionAccuracy_ipTM}}</span>
                </div>
                <div class="plddtlegends">
                  <span class="plddt-label">pDockQ2<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Estimates the expected quality of an interface by combining local residue confidence with confidence in the predicted relative positioning across the interface.'" [isOnlytext]="false" /></span>
                  <span>{{complexData().complexPredictionAccuracy_pDockQ2}}</span>
                </div>
                <div class="plddtlegends">
                  <span class="plddt-label">LIS<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Local Interaction Score (LIS) is derived from low PAE regions and reflects local confidence in the predicted interaction interface.'" [isOnlytext]="false" /></span>
                  <span>{{complexData().complexPredictionAccuracy_LIS}}</span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    }

    @if (summaryTexts.length === 0) {
      <section class="domain-info-loader">
        <div style="text-align: center; margin: 90px 0">
          <img src="../../assets/img/loader.gif" width="30px" />
        </div>
      </section>
    }

    <section>
    <div class="more-info" *ngIf="otherOrganismScientificNames && otherOrganismScientificNames.text.length">
      This exact same sequence is also present in {{otherOrganismScientificNames.totalCount}} species:
      <span>
        <span *ngIf="otherOrganismScientificNames.show_long">
          <i><span [innerHTML]="otherOrganismScientificNames.text"></span></i>
          <a
            *ngIf="getShortenedOrganismNames(otherOrganismScientificNames.text) != otherOrganismScientificNames.text"
            class="vf-link"
            (click)="switchText(otherOrganismScientificNames)"
            >
            <i class="icon icon-functional"></i> Show less
          </a>
        </span>
        <span *ngIf="!otherOrganismScientificNames.show_long">
          <i><span [innerHTML]="getShortenedOrganismNames(otherOrganismScientificNames.text)"></span></i>
          <a
            class="vf-link"
            *ngIf="checkOrganismHasToShowMore(otherOrganismScientificNames)"
            (click)="switchText(otherOrganismScientificNames)"
            >
            <i class="icon icon-functional"></i> Show more
          </a>
        </span>
        <!-- <span>
          &nbsp;&nbsp;<a class="vf-link" href="#">
          <i class="icon icon-functional"></i>Learn more...
        </a>
      </span> -->
    </span>
  </div>
</section>

<section>
  <div class="sequence-container">
    <div class="title">
      <span class="text">
        <!-- {{entryData().uniprotDescription ? entryData().uniprotDescription : 'Not named'}}, Sequence length {{ (entryData().sequenceEnd - entryData().sequenceStart) + 1 }}  -->
      </span>
      <div class="label-tooltip-seq" style="display: inline">
        @if (isCopySequence) {
          <span class="label-tooltip-seq-text">
            Sequence copied
          </span>
        }
        <button (click)="copySequence(entryData().sequence)">Copy sequence</button>
      </div>
    </div>
    <!-- <div class="sequence">
    <span> {{entryData().sequence}} </span>
  </div> -->

  <div class="summary-sequencepanel"></div>
</div>


</section>

<section>
  @if (hydrationReady) {
    <div class="structure-container">
      <!-- *ngIf="entryData().paeDocUrl" -->
      <app-pae-view
        [paeid]="'summary-paeviewer'"
        (selectedRegion)="cmSelectionUpdate($event)"
        [isMobilePae]="false"
        (click)="
          gaService.eventEmitter(
            'pae-click',
            'pae',
            'click',
            accession(),
            undefined
          )
          "
        >
      </app-pae-view>
      <div class="molstarView buttonContainer">
        @if (subSelectionOptions().length > 0) {
          <div class="subSelectionContainer">
            <div class="selector">
              <span class="molstar-control-txt">Select:</span>
              <button
                class="dropdown-button"
                mat-button
                [matMenuTriggerFor]="menu"
                >
                <span>{{currentSelection()}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M7 10.5L12 15.5L17 10.5H7Z" fill="black" />
                </svg>
              </button>
              <mat-menu #menu="matMenu" class="dropdown-menu" yPosition="below">
                @for (dropdownOption of subSelectionOptions(); track index; let index = $index;) {
                  <span
                    class="small"
                    mat-menu-item
                    (click)="toggleAccordionSubSelection(index)"
                    (mousedown)="$event.stopPropagation()"
                  >{{ dropdownOption }}</span>
                }
              </mat-menu>
            </div>
            <div class="buttons">
              <button class="small-flat-btn" (click)="zoomInCurrentSelection()">
                Zoom in
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5073 11.9322C11.9252 11.5144 12.2567 11.0183 12.4829 10.4723C12.709 9.92636 12.8255 9.34119 12.8255 8.75023C12.8256 8.15927 12.7092 7.57408 12.4831 7.02809C12.2569 6.4821 11.9255 5.98599 11.5076 5.56809C11.0898 5.15019 10.5937 4.81869 10.0478 4.5925C9.5018 4.36632 8.91663 4.24988 8.32566 4.24985C7.13216 4.24978 5.98751 4.72383 5.14352 5.56772C4.29954 6.4116 3.82535 7.5562 3.82528 8.7497C3.82521 9.94321 4.29926 11.0879 5.14315 11.9318C5.98704 12.7758 7.13163 13.25 8.32513 13.2501C9.51864 13.2502 10.6633 12.7761 11.5073 11.9322ZM12.5678 4.50722C13.6016 5.54077 14.2226 6.91622 14.314 8.37523C14.4054 9.83424 13.961 11.2764 13.0643 12.431L13.0988 12.4625L16.2803 15.644C16.421 15.7846 16.5001 15.9754 16.5002 16.1743C16.5002 16.3733 16.4213 16.5641 16.2806 16.7048C16.14 16.8456 15.9492 16.9247 15.7503 16.9247C15.5513 16.9248 15.3605 16.8458 15.2198 16.7052L12.0375 13.523L12.006 13.4892C10.8002 14.4232 9.28391 14.8629 7.76546 14.7191C6.247 14.5752 4.84032 13.8585 3.83134 12.7147C2.82237 11.5708 2.28682 10.0857 2.33357 8.56115C2.38032 7.03661 3.00586 5.58708 4.08302 4.50722C5.20822 3.38216 6.73423 2.75012 8.3254 2.75012C9.91657 2.75012 11.4426 3.38216 12.5678 4.50722ZM7.57502 5.74997H9.07502V7.99997H11.325V9.49997H9.07502V11.75H7.57502V9.49997H5.32502V7.99997H7.57502V5.74997Z" fill="black"></path></svg>
              </button>
              <button class="small-flat-btn" (click)="onZoomOut(zoomOutDuration)">
                Zoom out
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5073 11.9322C11.9252 11.5144 12.2567 11.0183 12.4829 10.4723C12.709 9.92636 12.8255 9.34119 12.8255 8.75023C12.8256 8.15927 12.7092 7.57408 12.4831 7.02809C12.2569 6.4821 11.9255 5.98599 11.5076 5.56809C11.0898 5.15019 10.5937 4.81869 10.0478 4.5925C9.5018 4.36632 8.91663 4.24988 8.32566 4.24985C7.13216 4.24978 5.98751 4.72383 5.14352 5.56772C4.29954 6.4116 3.82535 7.5562 3.82528 8.7497C3.82521 9.94321 4.29926 11.0879 5.14315 11.9318C5.98703 12.7758 7.13163 13.25 8.32513 13.2501C9.51864 13.2502 10.6633 12.7761 11.5073 11.9322ZM12.5678 4.50722C13.6016 5.54077 14.2226 6.91622 14.314 8.37523C14.4054 9.83424 13.961 11.2764 13.0643 12.431L13.0988 12.4625L16.2803 15.644C16.421 15.7846 16.5001 15.9754 16.5002 16.1743C16.5002 16.3733 16.4213 16.5641 16.2806 16.7048C16.14 16.8456 15.9492 16.9247 15.7503 16.9247C15.5513 16.9248 15.3605 16.8458 15.2198 16.7052L12.0375 13.523L12.006 13.4892C10.8002 14.4232 9.28391 14.8629 7.76546 14.7191C6.247 14.5752 4.84032 13.8585 3.83134 12.7147C2.82237 11.5708 2.28682 10.0857 2.33357 8.56115C2.38032 7.03661 3.00586 5.58708 4.08302 4.50722C5.20822 3.38216 6.73423 2.75012 8.3254 2.75012C9.91657 2.75012 11.4426 3.38216 12.5678 4.50722ZM7.57502 7.99997H9.07502H11.325V9.49997H9.07502L9.00006 9.49994L7.57502 9.49997H5.32502V7.99997H7.57502Z" fill="black"></path></svg>
              </button>
            </div>
          </div>
        }
        <div
          class="summary-molstar-container"
        ></div>
        <div class="feedback">
          <p>Share your feedback on the structure</p>
          <a class="vf-button vf-button--secondary vf-button--search-pdbe" style="color: #3B6FB6"
            href="https://docs.google.com/forms/d/e/1FAIpQLScT5V3h_-YLbeScz5vYBd8l1lcmdXuqViyXC0c0gRl0uOU1pw/viewform?entry.2122993774={{entryData().modelEntityId}}"
            target="_blank">
            Report an issue
          </a>
        </div>
      </div>
      <section class="legends-controls">
        <app-legends-panel (toggleAccordion)="toggleAccordion($event)" (toggleAccordionSelection)="toggleAccordionSelection($event)" (openedAccordionEmit)="openedAccordion($event)" [tedDomainData]="tedDomainData()" [csvAmData]="csvAmData()"></app-legends-panel>
        <div class="audit-container">
          <span class="audit-info"><b>Audit history </b></span>
          <span class="audit-info"><b>Model creation date:</b> <span class="infodate"> {{ entryData()?.modelCreatedDate | date: 'd MMM y' }}</span>
          <help-icon-with-tooltip [tooltipText]="'Date when the AlphaFold model for this entry was predicted.'" [isOnlytext]="false" />
        </span>
        @if (entryData()?.sequenceVersionDate) {
          <span class="audit-info"><b>Sequence version date:</b> <span class="infodate"> {{ entryData()?.sequenceVersionDate | date: 'd MMM y' }}</span>
          <help-icon-with-tooltip [tooltipText]="'The release date of the amino acid sequence from the reference database used to generate this model.'" [isOnlytext]="false" />
        </span>
        }
    </div>
  </section>
</div>
}
</section>
<div class="sectionContent"></div>
<section class="publication-container">
  <div class="publication-title">
    Dataset publication
  </div>

  @if (providerData()?.citations?.length) {
    <div>
      @for (citation of providerData().citations; track citation) {
        <div class="publication-desc">
          <a
            target="_blank"
            [href]="citation.url || '#'"
            class="public-link"
            >
            {{ citation.description || '' }}
          </a>
        </div>
      }
    </div>
  }
</section>
</div>
</div>
